import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";

const defaultOptions = {
    chart: {
        backgroundColor: "transparent",
        height: 640,
        width: 800,
        spacingTop: 20,
    },
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: false
    }
};

const LineChart = (props) => {
    return (
        <HighchartsReact
            options = {{
                ...defaultOptions,
                ...props.remainingOptions,
            }}
            highcharts = { Highcharts }
        />
    );
};

export default LineChart;